/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PurchasePlatformOrderFeeVo } from './PurchasePlatformOrderFeeVo';
import {
    PurchasePlatformOrderFeeVoFromJSON,
    PurchasePlatformOrderFeeVoFromJSONTyped,
    PurchasePlatformOrderFeeVoToJSON,
    PurchasePlatformOrderFeeVoToJSONTyped,
} from './PurchasePlatformOrderFeeVo';

/**
 * 
 * @export
 * @interface ResponseListPurchasePlatformOrderFeeVo
 */
export interface ResponseListPurchasePlatformOrderFeeVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListPurchasePlatformOrderFeeVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListPurchasePlatformOrderFeeVo
     */
    message?: string;
    /**
     * 
     * @type {Array<PurchasePlatformOrderFeeVo>}
     * @memberof ResponseListPurchasePlatformOrderFeeVo
     */
    data?: Array<PurchasePlatformOrderFeeVo>;
}

/**
 * Check if a given object implements the ResponseListPurchasePlatformOrderFeeVo interface.
 */
export function instanceOfResponseListPurchasePlatformOrderFeeVo(value: object): value is ResponseListPurchasePlatformOrderFeeVo {
    return true;
}

export function ResponseListPurchasePlatformOrderFeeVoFromJSON(json: any): ResponseListPurchasePlatformOrderFeeVo {
    return ResponseListPurchasePlatformOrderFeeVoFromJSONTyped(json, false);
}

export function ResponseListPurchasePlatformOrderFeeVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListPurchasePlatformOrderFeeVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(PurchasePlatformOrderFeeVoFromJSON)),
    };
}

export function ResponseListPurchasePlatformOrderFeeVoToJSON(json: any): ResponseListPurchasePlatformOrderFeeVo {
    return ResponseListPurchasePlatformOrderFeeVoToJSONTyped(json, false);
}

export function ResponseListPurchasePlatformOrderFeeVoToJSONTyped(value?: ResponseListPurchasePlatformOrderFeeVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(PurchasePlatformOrderFeeVoToJSON)),
    };
}

